export default __webpack_public_path__ + "static/media/pictogramBeaconEntertainment40.b2711257.svg";